export default __webpack_public_path__ + "static/media/logo.cba89297.svg";